// @ts-nocheck
import * as actions from './wixAdActions';
import reducer from './wixAdReducer';
import * as selectors from './wixAdSelectors';
import * as actionTypes from './wixAdActionTypes';

export { actions, reducer, selectors, actionTypes };
